const ENTRY_TAB_QUERY = 'entry';

/**
 * Returns the campaign tab from the URL.
 *
 * @returns The campaign tab.
 */
export function getCampaignTabFromUrl(): 0 | 1 {
  if (typeof window === 'undefined') {
    return 0;
  }

  return new URLSearchParams(window.location.search).get('t') ===
    ENTRY_TAB_QUERY
    ? 1
    : 0;
}

/**
 * Clears the campaign tab from the URL.
 *
 * @returns The campaign tab.
 */
export function clearCampaignTabFromUrl(): void {
  if (typeof window === 'undefined') {
    return;
  }

  const url = new URL(window.location.href);

  if (!url.searchParams.has('t')) {
    return;
  }

  url.searchParams.delete('t');
  window.history.replaceState(
    {},
    '',
    `${url.pathname}${url.search}${url.hash}`
  );
}

/**
 * Sets the campaign tab in the URL.
 *
 * @param tab - The campaign tab.
 */
export function setCampaignTabInUrl(tab: 0 | 1): void {
  if (typeof window === 'undefined') {
    return;
  }

  const url = new URL(window.location.href);

  if (tab === 1) {
    url.searchParams.set('t', ENTRY_TAB_QUERY);
  } else {
    url.searchParams.delete('t');
  }

  const nextUrl = `${url.pathname}${url.search}${url.hash}`;

  if (
    `${window.location.pathname}${window.location.search}${window.location.hash}` ===
    nextUrl
  ) {
    return;
  }

  window.history.replaceState({}, '', nextUrl);
}
